import React from 'react'
import {Box, Typography} from '@mui/material'
import {Config} from '../../../../utils/Config'
import {sanitizeContentHtml} from '../../../../utils/contentScreen'

export default function ContentScreenRender({content}) {
  const image = content?.image?.key ? content.image : null
  const bodyHtml = sanitizeContentHtml(content?.bodyHtml)
  const imageBelow = content?.imagePosition === 1

  const imageBlock = image ? (
    <Box component="figure" sx={{m: 0, mb: 2}}>
      <Box
        component="img"
        src={`${Config.BASE_URL}/Artifact/download?fileName=${encodeURIComponent(image.key)}`}
        alt={image.altText || ''}
        sx={{maxWidth: '100%', height: 'auto'}}
      />
      {image.caption && (
        <Typography component="figcaption" variant="caption">
          {image.caption}
        </Typography>
      )}
    </Box>
  ) : null

  const bodyBlock = bodyHtml ? (
    <div
      className="content-screen-body"
      dangerouslySetInnerHTML={{__html: bodyHtml}}
    />
  ) : null

  return (
    <Box
      className="content-screen"
      sx={{
        width: '100%',
        textAlign: 'left',
        '& li[data-list="bullet"]': {listStyleType: 'disc'},
      }}
    >
      {content?.headline && (
        <Typography variant="h5" component="h2" sx={{fontWeight: 600, mb: 1}}>
          {content.headline}
        </Typography>
      )}
      {content?.subheading && (
        <Typography variant="subtitle1" component="p" sx={{mb: 2}}>
          {content.subheading}
        </Typography>
      )}
      {!imageBelow && imageBlock}
      {bodyBlock}
      {imageBelow && imageBlock}
    </Box>
  )
}
